import React from "react";
import ProductGrid from "./components/ProductGrid";

function DarkSpots() {
  return <ProductGrid params={{ skinConcern: "dark-spots" }} />;
}

export default DarkSpots;
